export default "__VITE_ASSET__DHWvjcNS__"